import manager from "../Manager";

import { AppContext } from "../AppContext";
import { useContext } from "react";
import Utils from "../CourseApp/Helper/utils";
function MultipleChoicePreview({data, index, structures}) {

    const {globalState, updateGlobalState} = useContext(AppContext);
    const {values,selectedIndex, slides} = globalState;

    const selectedText = values[selectedIndex]?.answer;

    const handleClick = (text) => {
        if(!manager.inEditor) {
            let newValues = values;
            if(!newValues[selectedIndex]) {
                newValues[selectedIndex] = {};
            }
            newValues[selectedIndex].id = slides[selectedIndex].id;
            newValues[selectedIndex].answer = text;
            updateGlobalState('values.', newValues)
        }
    };

    return (
        <div className="tbcourse-template tbcourse-template-multiple-choice" key={index}>
            <div>
                <div className="tbcourse-template-text-title">
                    {typeof data.esay !== 'undefined' && data.esay.length > 0 ? (
                        // data.esay
                        <span dangerouslySetInnerHTML={{ __html: Utils.nl2br(data.esay) }} />
                        ) : (
                            structures.esay?.placeholder
                        )
                    }
                </div>
                <div className="tbcourse-template-multiple-choices">
                    <ul className="choice-options">
                        {data.answer?.map((item, k) => {
                            return (
                                <li key={`multiple-choice-` + selectedIndex + `-` + k} onClick={()=> handleClick(item.text)} className={`choice-options-item` + (!manager.inEditor && item.text===selectedText ? ` in-preview active` :``) + (manager.inEditor && item.correct ? ` active` :``) + (item.text.length === 0 ? ` empty`:``)}>
                                    <label>
                                        <input
                                            type="radio"
                                            value="option1"
                                            name="multiple"
                                            />
                                        {item.text.length > 0 ? (
                                            item.text
                                        ) : (
                                            <span className='text-muted'>Option {String.fromCharCode(65+k)}</span>
                                        )}
                                    </label>
                                </li>
                            );
                        })}

                    </ul>
                </div>
            </div>
        </div>
    )
}

export default MultipleChoicePreview;
